var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rowHoraNueva",style:(_vm.estilo_hora),on:{"click":function($event){return _vm.$emit('click',$event,_vm.hora)}}},[_vm._v(_vm._s(_vm.etiqueta))])}
var staticRenderFns = []

export { render, staticRenderFns }